import React, { useState } from "react";
import Header from "../header/header";
import Footer from "../footer/footer";
import Chat from "../chat/chat";
import Sidebar from "../sidebar/sidebar";
import { useEffect } from "react";

const Layout = ({ children }) => {
  const [show, setShow] = useState(false);
  const [openSidebar, setOpenSidebar] = useState(false);
  const[search, setSearch] = useState(false);
  const handleSidebar = () => {
    setOpenSidebar(!openSidebar);
    localStorage.setItem("sidebar", true);
    setShow(false);
    if(openSidebar){
      localStorage.removeItem("sidebar");
    }
  };

  const handleChat = () => {
      setShow(!show);
      setOpenSidebar(false);
  }

useEffect(() => {
  // const queryParams = new URLSearchParams(window.location.search);
  const pathname = window.location;
  if (pathname.pathname === '/search') {
    setSearch(true);
  }
}, [])
  return (
    <div className={`wrapper ${localStorage.getItem("sidebar") ? "opensidebar" : ""} ${localStorage.getItem("chat") ? 'chat-hide' : ''}`}>
      <Header handleSidebar={handleSidebar} search={search} />

      <div className="content-wrapper">
        <div className={`sidebar-wrapper`}>
          <Sidebar />
        </div>
        <div className={`content`}>
          {children}
          <Footer show={show} handleSidebar={handleSidebar} handleChat={handleChat} openSidebar={openSidebar} search={search} />
        </div>
        <div className={`chat-wrapper ${localStorage.getItem("chat") ? `chat-hide` : ``}`}>
          <Chat show={show} setShow={setShow} />
        </div>
      </div>
    </div>
  );
};

export default Layout;
